import { Form, Switch } from "antd";
import React from "react";

const OptionalItem = ({ optional, onChangeItem }) => {
  return (
    <Form.Item label={optional.name} name={optional.id}>
      <Switch defaultChecked={optional.available} onChange={onChangeItem}/>
    </Form.Item>
  );
};

export default OptionalItem;
